import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography,
} from 'lib/components';
import { IMAGE_FILES_PATH } from 'constants/AppConstants';
import { useTranslation } from 'lib/translation';
import ComingSoonStyles from './ComingSoonStyles';

function ComingSoon() {
  const { t } = useTranslation();
  const classes = ComingSoonStyles();
  return (
    <EVGrid className={classes.comingSoonScreen}>
      <EVPaper elevation={0}>
        <EVTypography className={classes.pageDescription}>
          {t('coming_soon__under_construction')}
        </EVTypography>
      </EVPaper>
      <EVPaper elevation={0}>
        <img
          className={classes.redirectionPageImage}
          src={`${IMAGE_FILES_PATH}/redirectionPageImage.png`}
          alt={t('coming_soon__redirection_page')}
        />
      </EVPaper>
    </EVGrid>
  );
}

export default ComingSoon;
